import { isExcludeProductSelection, isIncludeProductSelection, ProductSelection } from './ProductSelectionTypes';
import isEqual from 'lodash/isEqual';
import { LineItemKey } from '../../store/api';

export const getProductSelectionCount = (state: ProductSelection): number => {
    return isExcludeProductSelection(state) ? state.totalCount - state.excluded.length : state?.included.length ?? 0;
};

export const hasProductSelection = (state: ProductSelection) => !!state;

export function nothingSelected(state: ProductSelection) {
    return (
        !state ||
        (isExcludeProductSelection(state) && state.totalCount <= state.excluded.length) ||
        (isIncludeProductSelection(state) && state.included.length < 1)
    );
}

export function isSelected(lineItemKey: LineItemKey, productSelection: ProductSelection): boolean {
    if (isIncludeProductSelection(productSelection)) {
        return !!productSelection.included.find(item => isEqual(item, lineItemKey));
    }

    if (isExcludeProductSelection(productSelection)) {
        return !productSelection.excluded.find(item => isEqual(item, lineItemKey));
    }

    return false;
}
